export enum EmailDataType {
  Send = 'emailSend',
  Open = 'emailOpen',
  Click = 'emailClick',
  HostedUnsubscribeClick = 'hostedUnsubscribeClick',
  Complaint = 'emailComplaint',
  Bounce = 'emailBounce',
  SendSkip = 'emailSendSkip',
}

export enum GenericDataType {
  Subscribe = 'emailSubscribe',
  UnSubscribe = 'emailUnSubscribe',
  Purchase = 'purchase',
  CustomEvent = 'customEvent',
  User = 'user',
}

export enum JourneyDataType {
  JourneyExit = 'journeyExit',
}

export enum InAppDataType {
  Send = 'inAppSend',
  Open = 'inAppOpen',
  Click = 'inAppClick',
  Delivery = 'inAppDelivery',
  Close = 'inAppClose',
  Delete = 'inAppDelete',
  SendSkip = 'inAppSendSkip',
}

export enum InboxDataType {
  Session = 'inboxSession',
  MessageImpression = 'inboxMessageImpression',
}

export enum PushDataType {
  Send = 'pushSend',
  Open = 'pushOpen',
  Uninstall = 'pushUninstall',
  Bounce = 'pushBounce',
  SendSkip = 'pushSendSkip',
}

export enum SmsDataType {
  Send = 'smsSend',
  Bounce = 'smsBounce',
  Received = 'smsReceived',
  SendSkip = 'smsSendSkip',
  Click = 'smsClick',
  UsageInfo = 'smsUsageInfo',
}

export enum WebDataType {
  PushSend = 'webPushSend',
  PushClick = 'webPushClick',
  PushSendSkip = 'webPushSendSkip',
}

export enum WhatsAppDataType {
  WhatsAppSeen = 'whatsAppSeen',
  WhatsAppSendSkip = 'whatsAppSendSkip',
  WhatsAppBounce = 'whatsAppBounce',
  WhatsAppReceived = 'whatsAppReceived', // whatsAppReply
  WhatsAppClick = 'whatsAppClick',
  WhatsAppSend = 'whatsAppSend',
}

export type DataTypeType =
  | EmailDataType
  | GenericDataType
  | JourneyDataType
  | InAppDataType
  | InboxDataType
  | PushDataType
  | SmsDataType
  | WebDataType
  | WhatsAppDataType;
